import { defineMessages } from 'react-intl'

const scope = `procurify.modules.spending-cards.features.cancel-card-admin`

export default defineMessages({
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage: 'Card canceled',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Could not cancel card',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Do you want to cancel this card?',
  },
  modalDefaultContent: {
    id: `${scope}.modalDefaultContent`,
    defaultMessage:
      'The cardholder will no longer be able to use this spending card. Any outstanding balance on the card will be returned to your financial account.',
  },
  modalUserIsCardholderContent: {
    id: `${scope}.modalUserIsCardholderContent`,
    defaultMessage:
      'You will no longer be able to use this spending card. Any outstanding balance on the card will be returned to your financial account. ',
  },
  modalNegativeBalanceContent: {
    id: `${scope}.modalNegativeBalanceContent`,
    defaultMessage:
      "Canceling this card while it has a negative balance will deduct the deficit from your primary account's balance. The cardholder will no longer be able to access or allocate expenses to this card. This action is irreversible.",
  },
  modalUserIsCardholderNegativeBalanceContent: {
    id: `${scope}.modalUserIsCardholderNegativeBalanceContent`,
    defaultMessage:
      "Canceling this card while it has a negative balance will deduct the deficit from your primary account's balance. You will no longer be able to access or allocate expenses to this card. This action is irreversible.",
  },
  modalConfirmButton: {
    id: `${scope}.modalConfirmButton`,
    defaultMessage: 'Cancel card',
  },
})
